import { messagesRoot } from "./constants";

class ZipAttachmentFiles {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (file) => {
    const apiRoute = messagesRoot + "ZipAttachmentFiles";
    return await this.apiClass.callApiSkipErrorHandling("post", apiRoute, file);
  };
}

export default ZipAttachmentFiles;
